import { Checkbox, CheckboxChecked } from "@carbon/icons-react";
import { type ReactNode } from "react";

import { type ColumnType } from "../validation/parseColumnType";

/**
 * Returns the first and last labels for the column sort dropdown menu. For example, when sorting
 * text, the menu should say "Sort A -> Z" and "Sort Z -> A", while with numbers it should say "Sort
 * 1 -> 9" and "Sort 9 -> 1".
 */
export function columnSortLabels(fieldType: ColumnType | undefined): {
	first: ReactNode;
	last: ReactNode;
} {
	switch (fieldType) {
		case "Boolean":
			return { first: <CheckboxChecked />, last: <Checkbox /> };

		case "Number":
		case "Currency":
		case "Percent":
		case "Date":
		case "Time":
		case "Time distance to now":
		case "Date time":
			return { first: "1", last: "9" };

		case "Reaction":
			return { first: "most", last: "least" };

		case "URL":
		case "Email":
		case "Text":
			return { first: "A", last: "Z" };

		case "Tag":
		case "Auto":
		case "Link to record":
		default:
			return { first: "First", last: "Last" };
	}
}
